import { FC, MouseEvent } from 'react';

import { useIsLocalEnvironment } from '@telialt/core-eshop/src/hooks/useIsLocalEnvironment';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { LocalCode } from './GiftGroup.styles';

export const CopyLocalCode: FC<{ children: string }> = ({ children }) => {
    const isLocal = useIsLocalEnvironment();
    if (!isLocal) {
        return null;
    }

    const copyToClipboard = (e: MouseEvent<HTMLElement>) => {
        const value = e.currentTarget.textContent;
        navigator.clipboard.writeText(value);
        e.stopPropagation();
    };

    return (
        <LocalCode onClick={copyToClipboard} data-test={ESHOP_TEST_ID.GIFT_LOCAL_CODE}>
            {children}
        </LocalCode>
    );
};
